import API from "../api/api";
import Vue from "vue";
import VueCookies from "vue-cookies";
Vue.use(VueCookies);
const $API = new API();

export async function downloadDocument(url, name) {
  if (!url || !url.includes("https://md-booking.hmc.co.il/")) {
    return;
  }

  const isIOSSafari =
    /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  const isHmcApp = Vue.$cookies.get("cookie-user-agent") === "hmcAppUserAgent";

  if (isHmcApp) {
    // Flutter WebView on iOS: target="_blank" and download attributes are
    // ignored, so opening a new tab silently fails. Navigate the current
    // window directly — the Flutter navigation delegate will handle it
    // (e.g. open in the system browser or an in-app viewer).
    try {
      const response = await $API.getDocApp(url);
      const downloadUrl = response.message;
      window.location.href = downloadUrl;
    } catch (error) {
      throw error;
    }
  } else if (isIOSSafari) {
    const newWindow = window.open("", "_blank");

    try {
      const response = await $API.getDocApp(url);
      const downloadUrl = response.message;

      if (newWindow) {
        newWindow.location.href = downloadUrl;
      }

      createAndTriggerDownloadLink(downloadUrl, name);
    } catch (error) {
      if (newWindow) {
        newWindow.close();
      }
      throw error;
    }
  } else {
    try {
      const response = await $API.getDocApp(url);
      const downloadUrl = response.message;

      createAndTriggerDownloadLink(downloadUrl, name);
    } catch (error) {
      throw error;
    }
  }
}

/**
 * Creates a temporary download link and triggers the download
 * @param {string} downloadUrl - The URL to download from
 * @param {string} name - The filename for the download
 */
function createAndTriggerDownloadLink(downloadUrl, name) {
  const link = document.createElement("a");
  link.href = downloadUrl;
  link.download = name;
  link.target = "_blank";
  link.style.display = "none";

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export const emptySurgeryDocs = [
  {
    type: "clinic-confirm-agreement",
    files: [],
    title: "הסכמה מדעת לפעולה*"
  },
  {
    type: "reference-document",
    files: [],
    title: "סיכום ייעוץ לקראת ניתוח*"
  },
  {
    type: "ext-imaging-diagnosis",
    files: [],
    title: "פענוח בדיקות הדמייה"
  },
  { type: "", files: [], title: "קבצים נוספים" }
];

export const getSurgeryDocuments = async surgeryId => {
  const documents = JSON.parse(JSON.stringify(emptySurgeryDocs));
  const resDoc = await $API.getSurgeryDocuments(surgeryId);
  const docs = resDoc?.data?.data;
  if (!docs) return;

  docs.forEach(d => {
    const tmp = {
      id: d.id,
      name: d.file.file_name,
      path:
        "https://md-booking.hmc.co.il/ex-doctor/external" + d.file.full_path,
      type: d.type
    };

    if (d.type === "טופס הסכמה לפעולה חתום במרפאה") {
      documents[0].files.push(tmp);
    } else if (d.type === "הפניה קלינית של רופא") {
      documents[1].files.push(tmp);
    } else if (d.type === "פענוח דימות חיצוני") {
      documents[2].files.push(tmp);
    } else {
      documents[3].files.push(tmp);
      documents[3].type = d.type;
    }
  });

  return documents;
};
